import React, { useEffect } from 'react';
import { AmountInput } from '@alfa-bank/newclick-composite-components/amount-input';
import { type AmountType } from '@alfa-bank/newclick-types';
import { useAtom, useAtomValue } from 'jotai';

import { poolForEachAtom } from '../../atoms/money-pool-data/atom';
import { platformAtom } from '../../atoms/platform/atom';
import { transferAmountAtom, transferErrorAtom } from '../../atoms/transfer-amount/atom';

import styles from './index.module.css';

export const TransferInput = () => {
    const platform = useAtomValue(platformAtom);
    const poolForEach = useAtomValue(poolForEachAtom);

    const { amountForEach, amountHint } = poolForEach;

    const [transferAmount, setTransferAmount] = useAtom(transferAmountAtom);
    const [error, setError] = useAtom(transferErrorAtom);

    const handleChange = (amount: AmountType) => {
        if (error) {
            setError(null);
        }
        setTransferAmount(amount);
    };

    useEffect(() => {
        if (amountForEach) {
            setTransferAmount(amountForEach);
        }
    }, [amountForEach, setTransferAmount]);

    return (
        <AmountInput
            className={styles.input}
            dataTestId='transfer-input'
            size={platform === 'mobile' ? 56 : 72}
            block={true}
            hint={amountHint}
            label='Введите сумму'
            amount={transferAmount}
            onChange={handleChange}
            error={error}
        />
    );
};
